module.exports = __webpack_public_path__ + "static/media/swimming-pool.eae1bc6e.svg";